import { render, staticRenderFns } from "./Layoutpage.vue?vue&type=template&id=33a3a8b9&scoped=true"
import script from "./Layoutpage.vue?vue&type=script&lang=js"
export * from "./Layoutpage.vue?vue&type=script&lang=js"
import style0 from "./Layoutpage.vue?vue&type=style&index=0&id=33a3a8b9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33a3a8b9",
  null
  
)

export default component.exports